<template>
  <transition
    name="fade"
    v-if="!shouldBeHidden"
  >
    <div
      class="car-service-block card"
      :class="{ 'chosen': isServiceChosen }"
    >
      <div class="header">
        <h3 :style="{ fontFamily: fonts.secondary }">
          {{ type === 'predefined' ? 'Przegląd okresowy' : service.name }}
        </h3>
      </div>
      <div class="content">
        <p>
          {{ chosen && type === 'predefined' ? chosen.description : service.description }}
        </p>
        <standard-select
          v-if="type === 'predefined'"
          :options="selectOptions"
          :value="selectedMileage"
          @selected="$event ? onPredefinedSelected($event) : null"
          :arrow-color="buttonColor"
        />
        <p class="cost">
          {{ chosen && type === 'predefined' ? getFixedCost(chosen.grossPrice) : getFixedCost(service.grossPrice) }}
        </p>
      </div>
      <div class="footer">
        <standard-button
          custom-class="car-service-button fluid"
          :class="isServiceChosen ? 'selected' : 'primary'"
          @buttonClick="onClick()"
          :text="isServiceChosen ? 'Odznacz' : 'Wybierz'"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import StandardSelect from '~/StandardSelect';
import StandardButton from '~/StandardButton';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    service: {
      type: [Object, Array],
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    chosenMileage: {
      type: [String, Number],
      default: '',
    },
  },
  components: {
    StandardButton,
    StandardSelect,
  },
  data() {
    return {
      chosen: null,
      selectedMileage: null,
    };
  },
  computed: {
    ...mapGetters({
      fonts: 'brand/getFonts',
      buttonColor: 'brand/getThirdColor',
      primaryColor: 'brand/getPrimaryColor',
      chosenServices: 'carServices/chosenServices',
      actualMileage: 'visit/mileage',
      selectedServices: 'visit/selectedServices',
      allServices: 'carServices/services',
    }),
    selectOptions() {
      if (Array.isArray(this.service)) {
        return this.service.map(item => `${item.mileage} km`);
      }
      return null;
    },
    isServiceChosen() {
      const { chosenServices, service, chosen } = this;
      // eslint-disable-next-line
      const isFound = service => chosenServices.find(chosenService => {
        return chosenService.id == service.id;
      }) !== undefined;

      if (!this.chosen) {
        return isFound(service);
      }

      return isFound(chosen);
    },
    mileageOptions() {
      return this.service.mileage.split(',').map(item => `${item} km`);
    },
    shouldBeHidden() {
      if (this.chosenMileage) {
        return this.service.mileage.includes(this.chosenMileage);
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      chooseService: 'carServices/setChosenService',
      removeService: 'carServices/removeChosenService',
      setSelectedServices: 'visit/setSelectedServices',
      setMileage: 'visit/setMileage',
    }),
    onPredefinedSelected(eventValue) {
      if (this.type === 'predefined') {
        // eslint-disable-next-line
        const value = this.service.find(service => service.mileage == eventValue.slice(0, -3));
        this.chosen = value || this.selectOptions[0];
      }
    },
    getFixedCost(price) {
      if (price) {
        return `${price.toFixed(2).replace('.', ',')} PLN`;
      }
      return '';
    },
    setStep(value) {
      this.$emit('step', value);
    },
    onClick() {
      this.setStep(2);
      const {
        chosen, service, type, isServiceChosen, chosenServices, allServices,
      } = this;

      if (type === 'predefined') {
        if (chosenServices.find(chosenService => chosenService.id === chosen.id) !== undefined) {
          this.removeService(chosen);
        } else {
          this.chooseService(chosen);
          const predefinedIDs = allServices.predefined.map(service => service.id);
          const chosenID = chosen.id;
          chosenServices.forEach((chosenService) => {
            if (predefinedIDs.includes(chosenService.id) && chosenService.id !== chosenID) {
              this.removeService(chosenService);
            }
          });
        }
      } else if (isServiceChosen) {
        this.removeService(service);
      } else {
        this.chooseService(service);
      }

      this.setSelectedServices(this.chosenServices);
    },
  },
  mounted() {
    if (this.type === 'predefined') {
      // eslint-disable-next-line
      this.selectedMileage = this.selectOptions[0];
      this.chosen = this.service[0];

      let chosenPredefinedService = null;
      this.allServices.predefined.forEach((service) => {
        this.chosenServices.forEach((chosenService) => {
          if (service.id == chosenService.id) {
            chosenPredefinedService = service;
          }
        });
      });
      if (chosenPredefinedService) {
        this.selectedMileage = `${chosenPredefinedService.mileage} km`;
      }
    }
  },
  watch: {
    chosen(newVal) {
      this.$emit('chosen', { ...newVal, type: this.type });
    },
    actualMileage() {
      if (this.type === 'predefined') {
        const { selectOptions, actualMileage } = this;
        const options = selectOptions.map(option => parseInt(option.replace(' km', ''), 10));
        const mileage = parseInt(actualMileage, 10);
        const findClosest = function (x, arr) {
          const indexArr = arr.map(k => Math.abs(k - x));
          const min = Math.min(...indexArr);
          return arr[indexArr.indexOf(min)];
        };

        this.selectedMileage = `${findClosest(mileage, options)} km`;
        this.onPredefinedSelected(this.selectedMileage);
      }
    },
  },
};
</script>
